export const FORBIDDEN_WORD = [
  '키워드',
  '변녀',
  '자해',
  'AV배우',
  '딜도',
  '피스톤질',
  '창남',
  '시발',
  '씨발',
  '정액',
  '창년',
  '임신공장',
  '좆',
  '야썰',
  '근친',
  '자살',
  '개새끼',
  '미친년',
  '씹새',
  '십새',
  '병신',
  '젖만한',
  '젖나',
  '니미럴',
  '쌍년',
  '변태',
  '19금',
  '성관계',
  '개년',
  '썅',
  '쌍놈',
  '개놈',
  '지랄',
  '등신',
  '개자식',
  '염병',
  '개같은년',
  'c팔',
  '니애미',
  '니에미',
  '옘병',
  '개같은놈',
  '븅신',
  '죶',
  '씹년',
  '개같은뇬',
  '니앰',
  '앰창',
  '호로자식',
  '병시나',
  '개보지',
  '애비자지',
  '애미보지',
  '섹스',
  '빨통',
  '빠구리',
  '빠굴',
  '사까시',
  '번쎅',
  '낙태아',
  '엿먹어',
  '개자지',
  '걸레년',
  '곧휴',
  '갈보',
  '씹창',
  '자지를',
  '자지을',
  '자지가',
  '보지를',
  '보지을',
  '보지가',
  '유두',
  '젖꼭지',
  '최음제',
  'sex',
  '가슴을 만',
  '🔞',
  '신음',
  '창녀',
  '노예',
  '음란',
];
